import { forwardRef } from "react";
import type { OptionHTMLAttributes, ForwardedRef } from "react";

export const InputOption = forwardRef(
  (
    props: OptionHTMLAttributes<HTMLOptionElement>,
    ref: ForwardedRef<HTMLOptionElement>,
  ) => <option {...props} ref={ref} />,
);

InputOption.displayName = "InputOption";
